/**
 * IMPORTS
 */
import {gql} from '@apollo/client';


/**
 * EXPORTS
 */
export const BLOCK_WHATSAPP_CONTACT = gql`
mutation blockWhatsappContact($account: String!, $contact: String!) {
    blockWhatsappContact(account: $account, contact: $contact) {
        __typename
        ... on BlockWhatsappContact {
            account
	    contact
        }
        ... on Error {
            code
            info
        }
    }
}
`;

export const CREATE_CUSTOMER = gql`
mutation createCustomer ($input: CustomerInput!) {
    createCustomer (input: $input) {
        address1
        address2
        agents {
            uid
        }
        city
        code
        company
        contacts {
            channel
            id
            uid
            username
        }
        description
        document
        email
        id
        name
        organization
        state
        zipcode
    }
}
`;

/**
 * I am a mutation to remove a customer.
 */
export const REMOVE_CUSTOMER = gql`
mutation removeCustomer ($id: Int!) {
    removeCustomer (id: $id)
}
`;

/**
 * I am a mutation to update a costumer.
 */
export const UPDATE_CUSTOMER = gql`
mutation updateCustomer ($patch: CustomerPatch!) {
    updateCustomer(patch: $patch) {
        address1
        address2
        agents {
            uid
        }
        city
        code
        company
        contacts {
            channel
            id
            uid
            username
        }
        description
        document
        email
        id
        name
        organization
        state
        zipcode
    }
}
`;

/**
 * I am a mutation to tag a costumer.
 */
export const TAG_CUSTOMER = gql`
mutation tagCustomer ($customer: Int!, $tag: Int!) {
    tagCustomer(customer: $customer, tag: $tag) {
        id
        tag
    }
}
`;

/**
 * I am a mutation to unblock a whatsapp contact.
 */
export const UNBLOCK_WHATSAPP_CONTACT = gql`
mutation unblockWhatsappContact($account: String!, $contact: String!) {
    unblockWhatsappContact(account: $account, contact: $contact) {
        __typename
        ... on UnblockWhatsappContact {
            account
            contact
        }
        ... on Error {
            code
            info
        }
    }
}
`;

/**
 * I am a mutation to untag a costumer.
 */
export const UNTAG_CUSTOMER = gql`
mutation untagCustomer ($id: Int!) {
    untagCustomer(id: $id) {
        id
        tag
    }
}
`;
